import { axios } from 'apis';
import { Customer } from 'models';

const ENDPOINT = 'Customers';

export const CustomerService = {
	getAll: async (): Promise<Customer[]> => {
		const response = await axios.get<Customer[]>(`${ENDPOINT}`);
		return response.data;
	},
	getById: async (id: number): Promise<Customer> => {
		const response = await axios.get(`${ENDPOINT}/${id}`);
		return response.data;
	},
	create: async (data: Customer) => {
		const response = await axios.post(`${ENDPOINT}`, data);
		return (await response.data) as Customer;
	},
	update: async (data: Customer) => {
		const response = await axios.put(`${ENDPOINT}`, data);
		return (await response.data) as Customer;
	},
	delete: async (id: number) => {
		const response = await axios.delete(`${ENDPOINT}/${id}`);
		return (await response.data) as Customer;
	},
	getAllForUser: async (): Promise<Customer[]> => {
		const response = await axios.get(`${ENDPOINT}/GetAllForUser`);
		return response.data;
	},
};